// extracted by mini-css-extract-plugin
export default {"icon":"style_icon__SEkm2","dropdown":"style_dropdown__r36rE"};